// Menu data structure for the navbar
// Easily update categories and subcategories from here

export const menuData = [
  {
    id: 1,
    title: "देश-विदेश",
    submenu: [
      { label: "ब्रेकिंग न्यूज़", link: "/breaking-news" }
    ]
  },
  {
    id: 2,
    title: "उत्तर प्रदेश",
    submenu: [
      { label: "बड़ी खबर", link: "/up-news" }
    ]
  },
  {
    id: 3,
    title: "चित्रकूट",
    submenu: [
      { label: "5 ब्रेकिंग", link: "/chitrakoot-breaking" },
    ],
    megaMenu: {
      title: "चित्रकूट ब्लॉक्स",
      blocks: [

        {
          name: "कर्वी ब्लॉक",
          villages: [
            { name: "कर्वी", link: "/village/कर्वी" , image: "https://www.aljazeera.com/news/" },
            { name: "सीतापुर", link: "/village/सीतापुर" , image: "https://images.loksattaimg.com/2026/03/New-Project-2026-03-13T162455.659.jpg?w=440" },
            { name: "कोलगड़ा", link: "/village/कोलगड़ा" , image: "https://images.bhaskarassets.com/web2images/521/2026/03/13/61b1326c-19ba-4fe4-af0a-daadfa9e8130_1773375079455.jpg" },
            { name: "भरतकूप", link: "/village/भरतकूप" , image: "https://img.etimg.com/thumb/width-420,height-315,imgsize-46610,resizemode-75,msid-129551415/news/defence/iran-is-not-another-venezuela-trump-has-found-to-great-cost.jpg" },
            { name: "रानीपुर", link: "/village/रानीपुर" , image: "https://img.mathrubhumi.com/view/acePublic/alias/contentid/1prpk90wxdwuz5rcml9/0/trisha-jpg.webp?f=16%3A9&q=0.75&w=532" },
            { name: "बरुआ", link: "/village/बरुआ" , image: "https://akm-img-a-in.tosshub.com/aajtak/images/author/narendra-modi.png" },
            { name: "लोहरा", link: "/village/लोहरा" , image: "https://www.aljazeera.com/wp-content/uploads/2022/03/AP22056247719264.jpg?resize=770%2C513&quality=80" },
            { name: "देवांगना", link: "/village/देवांगना" , image: "https://www.aljazeera.com/wp-content/uploads/2024/02/2023-05-13T105359Z_980250140_RC2LX0AASDF6_RTRMADP_3_INDIA-POLITICS-KARNATAKA-1708147172.jpg?resize=770%2C513&quality=80" },
            { name: "कुसैली", link: "/village/कुसैली" , image: "https://www.newsonair.gov.in/wp-content/uploads/2025/09/yogi.jpg" },
            { name: "घुरेहटा", link: "/village/घुरेहटा" , image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkLxOl7IMykBJYvH40VacWM1b9ubR0NX2ivA&s" }
          ]
        },

        {
          name: "पहाड़ी ब्लॉक",
          villages: [
            { name: "पहाड़ी", link: "/village/पहाड़ी" , image: "https://www.aljazeera.com/news/" },
            { name: "देवल", link: "/village/देवल" , image: "https://images.loksattaimg.com/2026/03/New-Project-2026-03-13T162455.659.jpg?w=440" },
            { name: "सिरसावन", link: "/village/सिरसावन" , image: "https://images.bhaskarassets.com/web2images/521/2026/03/13/61b1326c-19ba-4fe4-af0a-daadfa9e8130_1773375079455.jpg" },
            { name: "अमरपुर", link: "/village/अमरपुर" , image: "https://img.etimg.com/thumb/width-420,height-315,imgsize-46610,resizemode-75,msid-129551415/news/defence/iran-is-not-another-venezuela-trump-has-found-to-great-cost.jpg" },
            { name: "सकरी", link: "/village/सकरी" , image: "https://img.mathrubhumi.com/view/acePublic/alias/contentid/1prpk90wxdwuz5rcml9/0/trisha-jpg.webp?f=16%3A9&q=0.75&w=532" },
            { name: "लखमापुर", link: "/village/लखमापुर" , image: "https://akm-img-a-in.tosshub.com/aajtak/images/author/narendra-modi.png" },
            { name: "गोपलपुर", link: "/village/गोपलपुर" , image: "https://www.aljazeera.com/wp-content/uploads/2022/03/AP22056247719264.jpg?resize=770%2C513&quality=80" },
            { name: "बरगढ़", link: "/village/बरगढ़" , image: "https://www.aljazeera.com/wp-content/uploads/2024/02/2023-05-13T105359Z_980250140_RC2LX0AASDF6_RTRMADP_3_INDIA-POLITICS-KARNATAKA-1708147172.jpg?resize=770%2C513&quality=80" },
            { name: "पिपरावल", link: "/village/पिपरावल" , image: "https://www.newsonair.gov.in/wp-content/uploads/2025/09/yogi.jpg" },
            { name: "भैसौंधा", link: "/village/भैसौंधा" , image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkLxOl7IMykBJYvH40VacWM1b9ubR0NX2ivA&s" }
          ]
        },

        {
          name: "मानिकपुर ब्लॉक",
          villages: [
            { name: "मानिकपुर", link: "/village/मानिकपुर" , image: "https://www.aljazeera.com/news/" },
            { name: "राजापुर", link: "/village/राजापुर" , image: "https://images.loksattaimg.com/2026/03/New-Project-2026-03-13T162455.659.jpg?w=440" },
            { name: "हनुमानगंज", link: "/village/हनुमानगंज" , image: "https://images.bhaskarassets.com/web2images/521/2026/03/13/61b1326c-19ba-4fe4-af0a-daadfa9e8130_1773375079455.jpg" },
            { name: "चिल्ली राकस", link: "/village/चिल्ली राकस" , image: "https://img.etimg.com/thumb/width-420,height-315,imgsize-46610,resizemode-75,msid-129551415/news/defence/iran-is-not-another-venezuela-trump-has-found-to-great-cost.jpg" },
            { name: "कछार", link: "/village/कछार" , image: "https://img.mathrubhumi.com/view/acePublic/alias/contentid/1prpk90wxdwuz5rcml9/0/trisha-jpg.webp?f=16%3A9&q=0.75&w=532" },
            { name: "टिकरिया", link: "/village/टिकरिया" , image: "https://akm-img-a-in.tosshub.com/aajtak/images/author/narendra-modi.png" },
            { name: "देवकली", link: "/village/देवकली" , image: "https://www.aljazeera.com/wp-content/uploads/2022/03/AP22056247719264.jpg?resize=770%2C513&quality=80" },
            { name: "घोड़ावल", link: "/village/घोड़ावल" , image: "https://www.aljazeera.com/wp-content/uploads/2024/02/2023-05-13T105359Z_980250140_RC2LX0AASDF6_RTRMADP_3_INDIA-POLITICS-KARNATAKA-1708147172.jpg?resize=770%2C513&quality=80" },
            { name: "कोठी", link: "/village/कोठी" , image: "https://www.newsonair.gov.in/wp-content/uploads/2025/09/yogi.jpg" },
            { name: "करौंदी", link: "/village/करौंदी" , image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkLxOl7IMykBJYvH40VacWM1b9ubR0NX2ivA&s" }
          ]
        },

        {
          name: "मऊ ब्लॉक",
          villages: [
            { name: "मऊ", link: "/village/मऊ" , image: "https://www.aljazeera.com/news/" },
            { name: "खरौंध", link: "/village/खरौंध" , image: "https://images.loksattaimg.com/2026/03/New-Project-2026-03-13T162455.659.jpg?w=440" },
            { name: "बरहा", link: "/village/बरहा" , image: "https://images.bhaskarassets.com/web2images/521/2026/03/13/61b1326c-19ba-4fe4-af0a-daadfa9e8130_1773375079455.jpg" },
            { name: "लोधवारा", link: "/village/लोधवारा" , image: "https://img.etimg.com/thumb/width-420,height-315,imgsize-46610,resizemode-75,msid-129551415/news/defence/iran-is-not-another-venezuela-trump-has-found-to-great-cost.jpg" },
            { name: "कोटरा", link: "/village/कोटरा" , image: "https://img.mathrubhumi.com/view/acePublic/alias/contentid/1prpk90wxdwuz5rcml9/0/trisha-jpg.webp?f=16%3A9&q=0.75&w=532" },
            { name: "रामपुर", link: "/village/रामपुर" , image: "https://akm-img-a-in.tosshub.com/aajtak/images/author/narendra-modi.png" },
            { name: "खपटिहा", link: "/village/खपटिहा" , image: "https://www.aljazeera.com/wp-content/uploads/2022/03/AP22056247719264.jpg?resize=770%2C513&quality=80" },
            { name: "सुरसेन", link: "/village/सुरसेन" , image: "https://www.aljazeera.com/wp-content/uploads/2024/02/2023-05-13T105359Z_980250140_RC2LX0AASDF6_RTRMADP_3_INDIA-POLITICS-KARNATAKA-1708147172.jpg?resize=770%2C513&quality=80" },
            { name: "बरदहा", link: "/village/बरदहा" , image: "https://www.newsonair.gov.in/wp-content/uploads/2025/09/yogi.jpg" },
            { name: "चंदई", link: "/village/चंदई" , image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkLxOl7IMykBJYvH40VacWM1b9ubR0NX2ivA&s" }
          ]
        },

        {
          name: "रामनगर ब्लॉक",
          villages: [
            { name: "रामनगर", link: "/village/रामनगर" , image: "https://www.aljazeera.com/news/" },
            { name: "नयागांव", link: "/village/नयागांव" , image: "https://images.loksattaimg.com/2026/03/New-Project-2026-03-13T162455.659.jpg?w=440" },
            { name: "बरुआ", link: "/village/बरुआ-रामनगर" , image: "https://images.bhaskarassets.com/web2images/521/2026/03/13/61b1326c-19ba-4fe4-af0a-daadfa9e8130_1773375079455.jpg" },
            { name: "तेंदुरा", link: "/village/तेंदुरा" , image: "https://img.etimg.com/thumb/width-420,height-315,imgsize-46610,resizemode-75,msid-129551415/news/defence/iran-is-not-another-venezuela-trump-has-found-to-great-cost.jpg" },
            { name: "कुर्रुहू", link: "/village/कुर्रुहू" , image: "https://img.mathrubhumi.com/view/acePublic/alias/contentid/1prpk90wxdwuz5rcml9/0/trisha-jpg.webp?f=16%3A9&q=0.75&w=532" },
            { name: "गोबरिया", link: "/village/गोबरिया" , image: "https://akm-img-a-in.tosshub.com/aajtak/images/author/narendra-modi.png" },
            { name: "डोढ़ा", link: "/village/डोढ़ा" , image: "https://www.aljazeera.com/wp-content/uploads/2022/03/AP22056247719264.jpg?resize=770%2C513&quality=80" },
            { name: "पटना", link: "/village/पटना" , image: "https://www.aljazeera.com/wp-content/uploads/2024/02/2023-05-13T105359Z_980250140_RC2LX0AASDF6_RTRMADP_3_INDIA-POLITICS-KARNATAKA-1708147172.jpg?resize=770%2C513&quality=80" },
            { name: "मड़फा", link: "/village/मड़फा" , image: "https://www.newsonair.gov.in/wp-content/uploads/2025/09/yogi.jpg" },
            { name: "सोनौरा", link: "/village/सोनौरा" , image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkLxOl7IMykBJYvH40VacWM1b9ubR0NX2ivA&s" }
          ]
        }

      ]
    }
  },
  {
    id: 4,
    title: "राजनीति",
    submenu: [
      { label: "संग्राम", link: "/politics" }
    ]
  },
  {
    id: 5,
    title: "शिक्षा",
    submenu: [
      { label: "जागरूकता", link: "/education" }
    ]
  },
  {
    id: 6,
    title: "धर्म",
    submenu: [
      { label: "सनातन", link: "/raashi" },
      { label: "सुविचार", link: "/suvichar" }
    ]
  },
  {
    id: 7,
    title: "मनोरंजन",
    submenu: [
      { label: "बैंड-बाजा", link: "/entertainment" }
    ]
  },
  // {
  //   id: 9,
  //   title: "इतिहास",
  //   submenu: [
  //     { label: "ज्ञानी बाबा", link: "/history" }
  //   ]
  // },
  {
    id: 10,
    title: "वीडियो",
    submenu: [
      { label: "वायरल", link: "/viral-videos" },
      { label: "चौपाल", link: "/chaupal-videos" }
    ]
  }
];


// Sidebar menu items
export const sidebarMenuData = [
  { label: "मिशन", link: "/mission" },
  { label: "टीम", link: "/team" },
  { label: "फीडबैक", link: "/feedback" }
];